import { setSearchTerm } from "../currenciesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useCurrencySearch = () => useSearch(s => s.data.listing.currencies.searchTerm, setSearchTerm);
